export default "__VITE_ASSET__Bh76VkMP__"